import { render } from "./home-page.vue?vue&type=template&id=3dc05270&scoped=true"
import script from "./home-page.vue?vue&type=script&lang=js"
export * from "./home-page.vue?vue&type=script&lang=js"

import "./home-page.vue?vue&type=style&index=0&id=3dc05270&lang=scss"
import "./home-page.vue?vue&type=style&index=1&id=3dc05270&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dc05270"]])

export default __exports__